import { Fragment } from 'react';
import { useFormikContext } from 'formik';
import cc from 'classcat';

import {
  OldPlatformLegalStatement,
  PaymentAndRegistrationForm,
  PurchaseConditionsIcons,
  SecureCheckoutLabel,
  SubmittingOverlay,
} from '#src/components/Cart';
import Container from '#src/components/Container';
import Notification from '#src/components/Notification';

import { formatScreenContent, selectMembershipOrderItem } from '../helpers';
import { withCheckoutForm } from '../withCheckoutForm';

import GameItem from './GameItem';
import Total from './Total';
import styles from './styles.module.scss';

const Component = ({
  className,
  ctaLabel,
  disabled,
  games,
  guaranteeDays,
  isAdHocMembershipOrder,
  order,
  paidNotification,
  requiresRegistration,
  savePaymentLabel,
  setBraintreeInstance,
  setPaymentMethodReady,
  theme,
  token,
}) => {
  const { isSubmitting } = useFormikContext();
  const { amountDue } = order;
  const membershipOrderItem = selectMembershipOrderItem(order);
  const content = formatScreenContent(membershipOrderItem?.screenContent || {});
  const isOrderFinal = order.status == 'final';

  return (
    <Fragment>
      {isSubmitting && <SubmittingOverlay />}
      <Container
        className={cc([styles.container, className])}
        outerClassName={styles.outerContainer}
      >
        {isOrderFinal && <Notification>{paidNotification}</Notification>}
        <div className={styles.cart}>
          {games?.map?.(({ game }) => (
            <GameItem key={game.id} game={game} />
          ))}
          <Total amountDue={amountDue} content={content} />
        </div>
        <hr className={styles.spacer} />

        <PurchaseConditionsIcons
          guaranteeDays={guaranteeDays}
          isOneTimeFeePurchase={true}
        />

        <SecureCheckoutLabel />

        {!isOrderFinal && (
          <PaymentAndRegistrationForm
            ctaLabel={ctaLabel}
            ctaDisabled={disabled}
            isAdHocMembershipOrder={isAdHocMembershipOrder}
            order={order}
            requiresRegistration={requiresRegistration}
            savePaymentLabel={savePaymentLabel}
            setBraintreeInstance={setBraintreeInstance}
            setPaymentMethodReady={setPaymentMethodReady}
            theme={theme}
            token={token}
          />
        )}

        {!!games?.length && !!content.braintreeDisclosureTrial && (
          <OldPlatformLegalStatement
            membershipDisclaimer={content.braintreeDisclosureTrial}
            theme={theme}
          />
        )}
      </Container>
    </Fragment>
  );
};

export const Simplified = withCheckoutForm(Component);
